<template>
    <div class="card p-3">
        <table class="table table-bordered table-striped mb-0">
            <thead class="thead-dark">
                <tr>
                    <th style="width: 60px;">#</th>
                    <th>Report Name</th>
                    <th style="width: 180px;">Downloaded On</th>
                    <th style="width: 140px;" class="text-center">Download</th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="(report, index) in formattedReports" :key="report.id">
                    <!-- SERIAL NUMBER -->
                    <td>{{ index + 1 }}</td>

                    <td>
                        <!-- VIEW PDF -->
                        <a href="javascript:void(0)" class="text-dark text-decoration-none"
                            @click="handleReport(report, true)">
                            {{ report.report_name }}{{ report.displaySuffix }}
                        </a>
                    </td>

                    <!-- DATE -->
                    <td>
                        {{ formatDate(report.created_at) }}
                    </td>

                    <td class="text-center">
                        <!-- DOWNLOAD PDF -->
                        <a href="javascript:void(0)" class="text-primary text-decoration-none"
                            @click="handleReport(report, false)">
                            <i class="fas fa-download mr-1"></i>
                        </a>
                    </td>
                </tr>

                <tr v-if="!formattedReports.length">
                    <td colspan="4" class="text-center text-muted">
                        No reports available
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    data() {
        return {
            reports: [],
            cloudStorageRoot: null,
        };
    },

    created() {
        this.cloudStorageRoot =
            this.$store.getters.getAPIKey.userAttachments;

        this.downloadCourseSyllabus();
    },

    computed: {
        formattedReports() {
            const groups = {};

            // Group by report_name
            this.reports.forEach(report => {
                if (!groups[report.report_name]) {
                    groups[report.report_name] = [];
                }
                groups[report.report_name].push(report);
            });

            const result = [];

            Object.values(groups).forEach(group => {
                // Sort latest first
                group.sort(
                    (a, b) => new Date(b.created_at) - new Date(a.created_at)
                );

                const total = group.length;

                group.forEach((report, index) => {
                    // Add suffix only if duplicates exist
                    report.displaySuffix =
                        total > 1 && index < total - 1
                            ? ` (${total - index - 1})`
                            : "";

                    result.push(report);
                });
            });

            // Final global sort (latest first)
            return result.sort(
                (a, b) => new Date(b.created_at) - new Date(a.created_at)
            );
        }
    },


    methods: {
        getFileUrl(file) {
            return (
                this.cloudStorageRoot +
                file.file_path +
                file.file_name
            );
        },

        getReportTitle(report) {
            return report.report_name || "Report";
        },

        formatDate(date) {
            const d = new Date(date);
            return d.toLocaleString("en-IN", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
            });
        },

        async handleReport(report, viewReport) {
            this.downloadData = true;

            try {
                const file = report.files[0];
                const fileUrl =
                    this.cloudStorageRoot + file.file_path + file.file_name;

                const response = await this.$axios.get(fileUrl, {
                    responseType: "blob",
                });

                const pdfBlob = new Blob([response.data], {
                    type: "application/pdf",
                });

                const pdfUrl = window.URL.createObjectURL(pdfBlob);
                let newTab = null;

                if (viewReport) {
                    newTab = window.open(pdfUrl, "_blank");
                }

                // fallback → download
                if (!newTab) {
                    if (viewReport) {
                        this.$toast.error(
                            "Failed to show pdf file, instead the file will be downloaded",
                            { position: "top", duration: 3000 }
                        );
                    }

                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute(
                        "download",
                        `${report.report_name}.pdf`
                    );
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                }

                this.downloadData = false;
            } catch (error) {
                this.$toast.error("Failed to Download, please try again", {
                    position: "top",
                    duration: 3000,
                });
                this.downloadData = false;
            }
        },

        async downloadCourseSyllabus() {
            const url =
                this.$store.getters.getAPIKey.mainAPI +
                `/report-downloads`;

            const response = await this.$axios.post(url);
            this.reports = response.data;
        },
    },
};

</script>
